<template>
	<el-container>
		<el-main class="get_qr_code" v-show="now_openid==''">
			<el-table :span="24" :data="connectedList" highlight-current-row v-loading="listLoading"  style="width: 100%;">
				<el-table-column type="index" >
				</el-table-column>
				<el-table-column  prop="name" label="用户昵称"  sortable>
				</el-table-column>
				<el-table-column  prop="upper_sysno" label="自定义数据" sortable>
					<template slot-scope="scope">
						<el-input  placeholder="自定义内容"  :readonly="true"></el-input>
				    </template>
				</el-table-column>
				<el-table-column prop="upper_sysno" label="发送数据"  sortable>
					<template slot-scope="scope">
				         <el-button :disabled='true' size="mini" @click="handleEdit(scope.$index, scope.row)">点击发送自定义数据</el-button>
				    </template>
				</el-table-column>
				<el-table-column prop="account" label="操作"  sortable>
					<template slot-scope="scope">
				        <el-button size="mini" @click="joinUser(scope.$index, scope.row)">点击接入用户</el-button>
				    </template>
				</el-table-column>
			</el-table>
		</el-main>
		<el-main class="get_qr_code showimg" v-show="now_openid!=''">
			<el-row class="break" >
				<el-button @click="breakusers">点击返回</el-button>
				<el-button @click='print'>打印</el-button>
			</el-row>
			<el-row class='setstyle'>
				<div>
				    <span >图片大小</span>
				  	<el-input v-model="myprint.width" placeholder="请输入内容"></el-input>
				</div>
				<div>
				    <span >上边距</span>
				    <el-input v-model="myprint.marginTop" placeholder="请输入内容"></el-input>
				</div>
				<div>
				    <span >左边距</span>
				    <el-input v-model="myprint.marginLeft" placeholder="请输入内容"></el-input>
				</div>
				<div>
				    <span >字体大小</span>
				    <el-input v-model="myprint.fontSize" placeholder="请输入内容"></el-input>
				</div>
				<div>
				    <span >链接后缀</span>
				    <el-input v-model="lasturl" disabled="true"  placeholder="请输入内容"></el-input>
				</div>
			</el-row>
			<!--<el-row class='wait' v-if='imgList.length==0'>-->
			<el-row class='wait' v-if='img.src==""'>
				等待设备输入
			</el-row>
			<!--<el-row >
				<el-col  v-for='image in imgList' class="imgs">
					<img width="200px" :src="image.webPath"/>
					<div style="width: 200px;text-align: center;" >{{image.macId}}</div>
					git push -u origin master
				</el-col>git remote set-url origin git+ssh://git@github.com/dongw-nocturn/simcotech.git
			</el-row>-->
			<!--class='img'-->
			<canvas id="canvas" width="200px" height="200px" style = "display: none;"></canvas>
			<el-row class='print-row'>
				<el-col class='prints' :style='myprint' ref="print" >
					<!--<div id="canvas-Img"></div>-->
					<!--<img  :src="img.webPath"/>-->
					<img  :src="img.src"/>
					<!--<img src="../img/bbecdb09cccbbe1ba96306e7dd5cadf7b30f4387.jpg"/>-->
					<!--<img src="../img/80e525f5571992fb50e5052e7aea0137a8fbc516.png"/>-->
					<div  >{{img.macId}}</div>
				</el-col>
				
			</el-row>
		</el-main>
	</el-container>
</template>

<script>
import QRCode from 'qrcode'
export default {
	data() {
		return {
			value:'',
			wsServer:'',
			messaged:'',
			showclosemessage:true,
			now_openid:'',//当前连接的用户openid
			connectedList:[],//远程用户列表
			listLoading: false,
			updata_message:'',
			now_type:'',
			message:'',
			usertype:0,
			img:{
				webPath:'',
				macId:'',
				src:''
			},
			myprint:{width:'100px',marginTop:'0px',marginLeft:'40%',fontSize:'10px'},
			imgList:[],
			lasturl:'wash',
			url:'',
		}
	},
	methods:{
		imgcreate:function(macId){
			let lasturl=this.lasturl
			this.url=`https://apw.simcotech.net/${lasturl}?scene=${macId}`
			let canvas=document.getElementById('canvas');
	        QRCode.toCanvas(canvas, this.url, error => {
	          if (error) console.error(error)
	          console.log('success!');
	        })
//	        let imgId = document.getElementById('canvas-Img');
			let dataURL = canvas.toDataURL("image/png"); //转图片  隐藏canvas
			this.img.src=dataURL;
//			imgId.innerHTML = '<img style="width: 320px;height: 158px;" src="' + dataURL + '"/>';
		},
		handleEdit(index, row) {//发送自定义数据，待改
			var that=this
    		console.log(index, row);
    		that.now_openid='';
 		},
 		print:function(){
			
 			console.log('打印')
 			this.$print(this.$refs.print)
 		},
 		joinUser(index, row){//接入用户
 			var that=this
 			console.log(index, row);
 			var meg={
				type:'motor_protection',
				user_type:'get_QR_code',
				organSysno:this.GLOBAL.organ_sysno,
				getopenId:row.openId
			}
 			console.log(row.openId)
 			this.now_openid=row.openId;
 			this.now_type=row.type;
			var meg_str=JSON.stringify(meg)
			that.wsServer.send(meg_str)
			console.log(this)
//			console.log(that.now_model)
 		},
		//返回用户列表发送断开连接
		breakusers:function(){
			this.getusers()
			this.now_openid=''
		},
		getusers:function (){//获取用户信息
			var that=this
			var meg={
			    getopenId:'',//接收某个发送者openId
				type:'motor_protection',
				user_type:'get_QR_code',
				organSysno:this.GLOBAL.organ_sysno
			}
			var meg_str=JSON.stringify(meg)
			this.wsServer.send(meg_str)
		},
		//16位二进制转换
		
		tryweb:function(){
			var that=this
			that.wsServer = new WebSocket('wss://apw.simcotech.net');
			var wsServer=that.wsServer
			wsServer.onopen = function (e) {
			 	that.getusers();
			 	(typeof e == 'string') && wsServer.send(e);//向后台发送数据
			};
			wsServer.onclose = function (e) {//当链接关闭的时候触发
				if(that.showclosemessage){
					alert('当前连接已断开')
				}
				that.imgList=[]
				console.log('关闭连接')
			};
			var imgs=[]
			wsServer.onmessage = function (e) {//后台返回消息的时候触发
//				console.log(e.data)
			 	if(e.data!='heartbeat'){
			 		//更新用户数据
			 		var message=JSON.parse(e.data)
			 		console.log(message)
			 		if(message.type=='getCreateUsers'){
				 		that.messaged=message
				   		var html = [];
				   		var user_connected=false;
	//			   		that.connectedList=message.data
				   		for(var i=0;i<message.data.length;i++){
							html.push(message.data[i])
				   		}
				   		that.connectedList=html
			 		}else if(message.type=='createImg'){
//			 			setTimeout(function(){
			 				that.img=message.data
							imgs.push(that.img)
							that.imgList=imgs
//							console.log(this.img)
//							},500)
			 			that.imgcreate(that.img.macId)
						
			 		}
			 		
			 	}else{
			   		console.log('心跳')
			 	}
			};
			wsServer.onerror = function (e) {//错误情况触发
				console.log(e)
			}
		}
	},
	mounted(){
		this.tryweb()
		
	},
	beforeDestroy(){
		this.showclosemessage=false;
		this.wsServer.close()
	},
}
</script>

<style>
	.get_qr_code{
		padding: 0;
		display: flex;
    	flex-wrap: wrap;
	}
	.showimg{
		flex-direction: column;
	}
	.get_qr_code .break,.get_qr_code .print-row,.get_qr_code .wait{
		width: 100%;
		height: 40px;
		margin: 15px 0;
	}
	.get_qr_code .wait{
		margin-top: 30px;
	}
	.el-main .get_qr_code>.el-row{
		height: auto;
	}
	/*页面显示样式*/
	.get_qr_code .el-row .img{
		width: 250px;
	}
	.get_qr_code .el-row .img div{
		font-size: 18px;
		height: 20px;
		line-height: 20px;
	}
	/*打印样式*/
	.prints{
		/*width: 100%;
		height: 100%;*/
		display: flex;
		flex-direction: column;
		justify-content: center; /* 水平居中 */
        align-items: center;     /* 垂直居中 */
		text-align: center;
	}
	.prints img{
		width: 100%;
	}
	.img img{
		 -webkit-filter: grayscale(100%) contrast(60%) saturate(100%) brightness(85%);
		  -moz-filter: grayscale(100%) contrast(60%) saturate(100%) brightness(85%) ; 
		  -ms-filter: grayscale(100%) contrast(60%) saturate(100%) brightness(85%); 
		  -o-filter: grayscale(100%) contrast(60%) saturate(100%) brightness(85%) ; 
		  filter: grayscale(100%) contrast(60%) saturate(100%) brightness(85%); 
		width: 250px ;
	}
	.prints div{
		
		/*font-size: 24px;*/
		height: 40px;
		font-family: "Microsoft YaHei";
		/*font-weight: bolder;*/
		line-height: 40px;
	}
	/*设置样式*/
	.setstyle{
		width: 50%;
	}
	.setstyle>div{
		display: flex;
		width: 80%;
	    height: 36px;
	    line-height: 36px;
	    font-size: 14px;
	}
	.setstyle .el-slider{
		width: 70%;
	}
	.setstyle span{
		width: 30%;
	}
</style>


// WEBPACK FOOTER //
// src/components/get_qr_code.vue